export const MOCK_DECISIONS = [
  {
    id: '1',
    source: 'ECAHO',
    decisionDate: '2024-05-13',
    reason: 'DOPING',
    horse: {
      name: 'HALHOLA AL HAWAJER',
      color: 'Grey',
      dob: '2019-03-11',
      regNo: '18368',
      studbook: 'UAE',
    },
    show: {
      name: 'Katara International Arabian Horse Festival (KIAHF)',
      level: 'Title show',
      dates: '1-5 Feb 2024',
      venue: 'Doha',
      country: 'Qatar',
    },
    penaltiesSummary: '• €4000 Fine\n• Disqualification from Show\n• 1 Year Ban',
    penaltiesDetails: `Regarding the above facts it is clear that the Horse was positive for controlled substances during the Show. The SDC on behalf of ECAHO in general and the welfare of the horses in particular, looks upon the use of forbidden substances amongst the highest levels of abuse. As it is hard to define a gradient in substance abuse, the SDC rules to fine at the maximum.\n\nTherefore, the following sanctions are decided by the SDC:\n\n• A €4000 fine.\n• Disqualification of the Horse from the applicable Show.\n• Loss of place, title, qualification, and the return of any trophies and/or prize money.\n• The PR will be liable for all costs of medication testing (A test) and subsequent costs of investigation, possible legal proceedings and all other follow-up costs arising out of this case. The costs for medication testing (A testing, sampling) will be charged by the show organizer (QREC).\n• The PR will be liable for all costs of medication testing (B test).\n• The Horse will be banned from participating in any ECAHO affiliated show for a period of one (1) year after the day the sanctions were imposed by the SDC (day of sanctions imposed: 13 May 2024, banned until 13 May 2025).\n• If the fine is not paid within the due period, any horses from the PR entered at any ECAHO affiliated shows, will not be allowed to be shown until the full amount of the fine is received by ECAHO.`,
    penalties: [
      {
        type: 'Financial Penalty',
        detail: 'A €4000 fine',
      },
      {
        type: 'Event Status',
        detail: 'Disqualification from the applicable Show',
      },
      {
        type: 'Titles & Ranks',
        detail: 'Loss of place/title/qualification',
      },
      {
        type: 'Restitution',
        detail: 'Return of trophies/prize money',
      },
    ],
  },
  {
    id: '2',
    source: 'NATIONAL AUTH.',
    decisionDate: '2024-04-02',
    reason: 'CONDUCT',
    handler: {
      name: 'Ahmed Al Mansoori',
    },
    show: {
      name: 'Abu Dhabi International Championship',
      dates: '1-5 Feb 2024',
    },
    penaltiesSummary: 'Formal Warning, Loss of points.',
    penalties: [
      {
        type: 'Warning',
        detail: 'Formal written warning issued',
      },
      {
        type: 'Titles & Ranks',
        detail: 'Loss of points for the 2024 season',
      },
    ],
  },
  {
    id: '3',
    source: 'ECAHO',
    decisionDate: '2024-02-15',
    reason: 'DOPING',
    horse: {
      name: 'MARAJJ AL BIDAYA',
      color: 'Grey',
      dob: '2019-03-11',
      regNo: '18368',
      studbook: 'UAE',
    },
    show: {
      name: 'Sharjah International Arabian Horse Festival',
      dates: '1-5 Feb 2024',
    },
    penaltiesSummary: 'Suspension (1 Year), Stripped of title.',
    penalties: [
      {
        type: 'Suspension',
        detail: '1 Year suspension from all ECAHO events',
      },
      {
        type: 'Titles & Ranks',
        detail: 'Stripped of title',
      },
    ],
  },
];

export const filterDecisions = async (filters) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      let result = [...MOCK_DECISIONS];
      
      if (filters.search) {
        const query = filters.search.toLowerCase();
        result = result.filter(d => 
          (d.horse && d.horse.name.toLowerCase().includes(query)) ||
          (d.handler && d.handler.name.toLowerCase().includes(query)) ||
          (d.show && d.show.name.toLowerCase().includes(query))
        );
      }
      
      if (filters.reason && filters.reason !== 'All Reasons') {
        result = result.filter(d => d.reason.toLowerCase() === filters.reason.toLowerCase());
      }
      
      if (filters.year && filters.year !== 'All Years') {
        result = result.filter(d => d.decisionDate.startsWith(filters.year));
      }

      const totalCount = result.length;

      // Pagination
      if (filters.skip !== undefined && filters.take !== undefined) {
        result = result.slice(filters.skip, filters.skip + filters.take);
      }

      resolve({
        totalCount,
        result
      });
    }, 500); // Simulate network delay
  });
};

export const getDecisionById = async (id) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const decision = MOCK_DECISIONS.find(d => d.id === id);
      resolve(decision || null);
    }, 300);
  });
};
